import { createTranslocoScope } from '@gde-mit/angular-core';

export const KT_TRANSLOCO = createTranslocoScope('KT', (lang) => import(`./i18n/${lang}.json`));

export const ACTIVITY_BROWSER_I18N_PREFIX = 'ACTIVITY_BROWSER';

/** Transloco prefix for the activity-browser advanced filter panel. */
export const ACTIVITY_FILTER_PANEL_I18N_PREFIX = `${ACTIVITY_BROWSER_I18N_PREFIX}.FILTER_PANEL`;

/** Transloco prefix for guided activity wizard copy under `ACTIVITY_BROWSER.GUIDED_WIZARD`. */
export const GUIDED_ACTIVITY_WIZARD_I18N_PREFIX = `${ACTIVITY_BROWSER_I18N_PREFIX}.GUIDED_WIZARD`;
/** Transloco prefix for first-user-experience overlay copy. */
export const FUE_I18N_PREFIX = 'FUE';

/** Transloco prefix for the profile-setup ("Teaching preferences") overlay copy. */
export const PROFILE_SETUP_I18N_PREFIX = 'PROFILE_SETUP';

/** Transloco prefix for the profile popup copy. */
export const PROFILE_I18N_PREFIX = 'PROFILE';

/** Transloco prefix for the shared copy. */
export const SHARED_I18N_PREFIX = 'SHARED';

/** @deprecated Import from `projects/projects.transloco` inside the projects domain. */
export { PROJECTS_I18N_PREFIX, PROJECTS_TRANSLOCO } from './projects/projects.transloco';
